var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"exams-list-item__actions-btn",on:{"click":_vm.action}},[_c('exams-list-action-btn-icon',{attrs:{"service-type":_vm.serviceType,"action-type":_vm.actionType}}),_c('span',{staticClass:"exams-list-item__actions-btn-label"},[_vm._v(_vm._s(_vm.getActionLabel()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }